import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { FeatureFlags } from "@/modules/feature-flags/consts/FeatureFlags";
import {
  awaitFeatureFlagsLoaded,
  isFeatureEnabled,
} from "@/modules/feature-flags/utils/posthog";
import { SurveyScreen } from "@/modules/session-survey/screens/SurveyScreen";
import { ENTRY_POINTS } from "@/modules/tracking/consts/EntryPoints";
import { registerBookingSuperProperties } from "@/modules/tracking/utils/registerBookingSuperProperties";

const surveySearchParams = z.object({
  // Survey links arrive via email/SMS and external apps; an invalid client
  // must degrade to default attribution, never break the link.
  client: z.enum(ENTRY_POINTS).optional().catch(undefined),
});

export const Route = createFileRoute("/survey/$id")({
  validateSearch: surveySearchParams,
  beforeLoad: async ({ search }) => {
    await awaitFeatureFlagsLoaded();
    if (!isFeatureEnabled(FeatureFlags.PostSessionSurvey, true)) {
      throw redirect({ to: "/not-found" });
    }
    // Registered before the screen mounts so survey events (shown/started/
    // completed) carry the entry point too — mirrors /embed/book's beforeLoad.
    registerBookingSuperProperties({ entryPoint: search.client });
  },
  component: SurveyRoute,
});

function SurveyRoute() {
  const { id } = Route.useParams();

  return <SurveyScreen surveyId={id} />;
}
